import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

import './Gamburger.css';
import { IconLoader } from 'common/IconLoader';
import { setActivePolygon } from 'redux/actions';

const Gamburger = (props) => {
  const {
    currentPolygon,
    isSelected,
    isActive,
    handlerGamburgerClick
  } = props;

  const activePolygonId = useSelector((store) => store.ui.devicesPage.activePolygonId);
  const dispatch = useDispatch();

  const [isHovered, setIsHovered] = useState(false);
  const gamburgerRef = useRef();

  const handlerOnClick = () => {
    // Polygon activates if it is necessary
    if (currentPolygon.deviceGroupId !== activePolygonId) {
      dispatch(setActivePolygon(currentPolygon.deviceGroupId));
    }

    if (!isSelected) {
      handlerGamburgerClick(gamburgerRef, currentPolygon);
    }
  };

  return (
    <div
      className={classNames({
        'Gamburger': true,
        'Gamburger_Hovered': isHovered,
        'Gamburger_Selected': isSelected,
        'Gamburger_Blocked': isSelected && !isActive
      })}
      ref={gamburgerRef}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handlerOnClick}
    >
      <img
        src={IconLoader.icon_dots_vertical}
        draggable='false'
        alt='dots'
      />
    </div>
  )
};

export default Gamburger;